import axios from 'axios';
import { toast } from 'react-toastify';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://adey.lucky.et/api',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Required for CORS/session
});

// Request interceptor to add token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); 
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle session expiration
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Check for 403 status and the specific error message from the backend
    if (
      error.response &&
      error.response.status === 403 &&
      (error.response.data?.error === 'Session expired or logged in from another device' ||
       error.response.data?.error === 'Token expired. Please log in again.' || // Added for token expired
       error.response.data?.error === 'Invalid token: Missing user ID or session ID.' || // Added for missing claims
       error.response.data?.error === 'User not found. Session invalid.' || // Added for user not found
       error.response.data?.error === 'Invalid token' // Generic invalid token error
      )
    ) {
      localStorage.removeItem('token');
      localStorage.removeItem('userId');

      // Customize the toast message based on the specific error
      let toastMessage = 'Your session has expired. Please log in again.';
      if (error.response.data?.error === 'Session expired or logged in from another device') {
        toastMessage = 'Your session has ended because your account was logged in from another device. Please log in again.';
      } else if (error.response.data?.error === 'Token expired. Please log in again.') {
        toastMessage = 'Your session has expired. Please log in again.';
      } else if (error.response.data?.error === 'Invalid token: Missing user ID or session ID.') {
        toastMessage = 'Security issue detected. Please log in again.';
      } else if (error.response.data?.error === 'User not found. Session invalid.') {
        toastMessage = 'User not found or session invalid. Please log in again.';
      }

      toast.error(toastMessage);

      setTimeout(() => {
        window.location.href = '/login?session=expired';
      }, 3000);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
